export default __webpack_public_path__ + "static/media/Icon_Locked_16px.e444d384.svg";